import React from 'react'
import styled from 'styled-components'
import breakpoints from '../../vars/breakpoints'
import gutters from '../../vars/gutters'
import colors from '../../vars/colors'

export const HeaderWrapper = styled.div`
    background-color: ${colors['white-two']};
    transition: background-color 300ms ease-in-out;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    .logoHolder {
        display: flex;
        align-items: center;
        height: 70px;
        transition: opacity 300ms ease-in-out;
        opacity: '1';
        pointer-events: 'all';
        @media (max-width: ${breakpoints['bp-mobile']}) {
            height: 54px;
        }
    }
`

export const CityMenuWrapper = styled.div`
    position: absolute;
    left: 150px;
    right: 150px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .menuLabel,
    .city,
    .state {
        font-family: 'OneDotExt', sans-serif;
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
        cursor: pointer;
    }
    .city,
    .state {
        color: ${colors['peacock-blue']};
    }
    .arrow {
        display: inline-block;
        transform-origin: center center;
        transform: rotate(180deg);
        margin-bottom: 2px;
        margin-left: 5px;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid ${colors['peacock-blue']};
        transition: transform 300ms ease-in;
        &.active {
            transform: rotate(0deg);
        }
    }
`

export const BackCarrot = styled.div`
    display: inline-block;
    height: 15px;
    width: 15px;
    box-sizing: border-box;
    transform-origin: center center;
    border-bottom: 5px solid ${colors['peacock-blue']};
    border-left: 5px solid ${colors['peacock-blue']};
    border-radius: 2px;
    transform: rotate(45deg) translate(-2px, -8px);
`



// WEBPACK FOOTER //
// ./src/components/header/styled-components.js